/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

export default hashDelete;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_hashDelete.js
// module id = null
// module chunks = 